var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetpassImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_12254",
    "data-name": "Grupo 12254",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.97,
    height: 52.463,
    viewBox: "0 0 53.97 52.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4263",
    "data-name": "Rect\\xE1ngulo 4263",
    width: 53.97,
    height: 52.463,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12253",
    "data-name": "Grupo 12253",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_841",
    "data-name": "Trazado 841",
    d: "M22.887,21.69a2.69,2.69,0,1,0-4.036,2.316v3.064a1.345,1.345,0,0,0,2.69,0V24.007a2.682,2.682,0,0,0,1.345-2.316",
    transform: "translate(6.043 6.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_842",
    "data-name": "Trazado 842",
    d: "M33.233,16.417H31.175C30.9,11.167,27.4,7,23.131,7s-7.765,4.167-8.044,9.417H13.028a4.027,4.027,0,0,0-4.022,4.022V36.608a4.026,4.026,0,0,0,4.022,4.022H33.233a4.026,4.026,0,0,0,4.022-4.022V20.439a4.027,4.027,0,0,0-4.022-4.022M23.131,9.69c2.8,0,5.108,2.961,5.357,6.726H17.774c.249-3.765,2.555-6.726,5.357-6.726M34.565,36.608a1.333,1.333,0,0,1-1.332,1.332H13.028A1.333,1.333,0,0,1,11.7,36.608V20.439a1.334,1.334,0,0,1,1.332-1.332H33.233a1.334,1.334,0,0,1,1.332,1.332Z",
    transform: "translate(3.109 2.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_843",
    "data-name": "Trazado 843",
    d: "M26.24,0A26.237,26.237,0,0,0,3.455,13.257l-.821-2.748a1.345,1.345,0,1,0-2.577.768l1.722,5.772c.005.016.017.027.023.042s0,.032.008.048a1.2,1.2,0,0,0,.117.186,1.218,1.218,0,0,0,.141.227,1.366,1.366,0,0,0,.194.159,1.374,1.374,0,0,0,.214.152,1.422,1.422,0,0,0,.237.074A1.285,1.285,0,0,0,2.968,18a1.355,1.355,0,0,0,.264-.024,1.359,1.359,0,0,0,.221-.02c.016-.005.027-.017.043-.023s.031,0,.047-.007L9.177,15.8a1.345,1.345,0,1,0-.948-2.518l-2.151.813a23.536,23.536,0,0,1,43.7,12.139,1.345,1.345,0,0,0,2.69,0A26.262,26.262,0,0,0,26.24,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_844",
    "data-name": "Trazado 844",
    d: "M53.886,31.632l-2.078-5.653c-.007-.016-.019-.026-.026-.042s0-.031-.011-.047a99.68,99.68,0,0,1-.284-.4,1.289,1.289,0,0,0-.2-.147,1.693,1.693,0,0,0-.722-.242,51.159,51.159,0,0,0-.48.075c-.016.005-.026.019-.04.024s-.032,0-.047.011L44.5,27.689a1.345,1.345,0,0,0,1.1,2.454l2.252-1.014A23.532,23.532,0,0,1,2.7,19.845a1.345,1.345,0,1,0-2.69,0A26.222,26.222,0,0,0,50.415,29.987l.946,2.573a1.345,1.345,0,1,0,2.525-.928",
    transform: "translate(0.002 6.386)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpassImage);
export default __webpack_public_path__ + "static/media/resetpassImage.fbe8e0d5ae6305f2371e3bdd42153f5a.svg";
export { ForwardRef as ReactComponent };